import { useState, useEffect } from 'react';
import { useParams, Link, useNavigate, useLocation } from "react-router-dom";
import RpLogo from "../img/sidebarLogo.svg";
import { BASE_URL_API, IMG_URL } from "../environment";
import axios from "axios";

export const Invoice = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const id = localStorage.getItem("customer_id");
  const params = new URLSearchParams(location.search);
  const yr = params.get("yr");
  const mn = params.get("mn");

  const [items, setItems] = useState([]);
  const [alldetails, setAllDetails] = useState([]);
  const [itemIds, setItemIds] = useState([]);
  const [isGst, setIsGst] = useState(false);
  const [updatedItems, setUpdatedItems] = useState([]);
  const [gstMap, setGstMap] = useState({});
  const [customerProfile, setCustomerProfile] = useState([])

  const fetchData = () => {
    axios
      .get(`${BASE_URL_API}orders/bscustomerIndItems/${id}?month=${mn}&year=${yr}`)
      .then((res) => {
        setItems(res.data);
        if (res.data) {
          setItemIds(res.data.map(item => item.itemId));
        }
      })
      .catch((err) => console.log(err));

    axios
      .get(`${BASE_URL_API}customers/getcustomerdetails/${id}`)
      .then((res) => {
        console.log("the data is", res.data.address_data);

        if (res.data.customer_data?.gstNumber) {
          setIsGst(true);
          setCustomerProfile(res.data.customer_data);

        }

        if (res.data.customer_profile) {
          setCustomerProfile(res.data.customer_profile);
        }

        if (res.data.address_data) {
          setAllDetails(res.data.address_data);
        }
      })
      .catch((err) => console.log(err));
  }

  console.log("******", alldetails);
  console.log("the customer profile is",customerProfile);

  const getPercentage = () => {
    if (itemIds.length === 0) return;

    axios
      .post(`${BASE_URL_API}items/getgstpercentage`, { items: itemIds })
      .then((res) => {
        const newGstMap = {};
        res.data.data.forEach(item => {
          newGstMap[item.item_id] = {
            gst_percentage: item.gst_percentage,
            cgst_percent: parseFloat(item.cgst) || 0,
            sgst_percent: parseFloat(item.sgst) || 0,
            hsn: item.hsn
          };
        });
        setGstMap(newGstMap);
      })
      .catch((err) => console.log(err));
  };
  console.log(gstMap);

  useEffect(() => {
    if (mn && yr && id) {
      fetchData();
    }
  }, [id, mn, yr]);

  useEffect(() => {
    getPercentage();
  }, [itemIds]);

  useEffect(() => {
    const newUpdatedItems = items.map((item) => {
      const gst = gstMap[item.itemId] || { cgst_percent: 0, sgst_percent: 0 };
      const quantity = parseFloat(item.totalWeight) || 0;
      const price = parseFloat(item.totalPrice) || 0;
      const cgstPerUnit = parseFloat(gst.cgst_percent) || 0;
      const sgstPerUnit = parseFloat(gst.sgst_percent) || 0;

      const totalCGST = quantity * cgstPerUnit;
      const totalSGST = quantity * sgstPerUnit;
      const totalAmount = price;
      const hsn = gst.hsn;
      console.log(gst.hsn);
      return {
        ...item,
        cgst: totalCGST.toFixed(2),
        sgst: totalSGST.toFixed(2),
        cgst_per_unit: cgstPerUnit,
        sgst_per_unit: sgstPerUnit,
        totalAmount: totalAmount.toFixed(2),
        hsn: hsn || 'N/A',
        quantity: quantity,
        unit: item.unit || 'KG'
      };
    });

    setUpdatedItems(newUpdatedItems);
    calculateTotals(newUpdatedItems);
  }, [items, gstMap]);

  const [totals, setTotals] = useState({
    subtotal: 0,
    sgst: 0,
    cgst: 0,
    cess: 0,
    grandTotal: 0
  });

  const calculateTotals = (itemsData) => {
    let subtotal = 0;
    let totalSgst = 0;
    let totalCgst = 0;
    let totalCess = 0;
    let grandTotal = 0;

    itemsData.forEach(item => {
      const rowSubtotal = parseFloat(item.totalPrice) || 0;
      const sgst = parseFloat(item.sgst) || 0;
      const cgst = parseFloat(item.cgst) || 0;
      const cess = 0;

      subtotal += rowSubtotal;
      totalSgst += sgst;
      totalCgst += cgst;
      totalCess += cess;
      grandTotal += rowSubtotal;
    });

    setTotals({
      subtotal: subtotal.toFixed(2),
      sgst: totalSgst.toFixed(2),
      cgst: totalCgst.toFixed(2),
      cess: totalCess.toFixed(2),
      grandTotal: grandTotal.toFixed(2)
    });
  };

  const printReceipt = () => {
    window.print();
  };

  const goBack = () => {
    navigate(-1);
  };

  const generateInvoiceNumber = () => {
    const prefix = "RPINV";
    let current = parseInt(localStorage.getItem("invoiceSerial")) || 0;
    current += 1;
    localStorage.setItem("invoiceSerial", current);
    const serial = String(current).padStart(3, "0");
    return prefix + serial;
  };

  const getCurrentDate = () => {
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const yyyy = today.getFullYear();
    return `${dd}-${mm}-${yyyy}`;
  };

  return (
    <div className="receipt-content py-4">
      <div className="container bootstrap snippets bootdey">
        <div className="row">
          <div className="col-md-12">
            <div className="invoice-wrapper mt-0">
              <div className="d-flex justify-content-between align-items-center border-bottom pb-3 mb-4">
                <h2 className="mb-0 fs-3 fs-md-2 fs-lg-1" style={{ color: "#73be44" }}>INVOICE</h2>
                <div className="d-flex align-items-center">
                  {alldetails?.imageURL && (
                    <img
                      src={`${IMG_URL}${alldetails.customer_data.imageURL}`}
                      alt="Company Logo"
                      className="me-4"
                      style={{ width: '200px' }}
                    />
                  )}
                </div>
              </div>

              <div className="mb-4 d-flex justify-content-between" style={{ fontSize: "14px" }}>
                <div className="col-md-6">
                  <div className="mb-3">
                    {!isGst ? (
  <div>{customerProfile.name || 'Customer name not available'}</div>
) : (
  <div>{customerProfile?.companyName || 'GST customer name not available'}</div>
)}

                    {isGst && (
  <div>GSTIN: {customerProfile.gstNumber || "NA"}</div>
)}

                    <div>
                      {!isGst ? (
                        // Render this if isGst is false
                        alldetails ? (
                          <>
                            {alldetails.location}, 
                            {alldetails.city}, 
                            {alldetails.PIN}
                          </>
                        ) : (
                          'Address not available'
                        )
                      ) : (
                        // Render this if isGst is true
                        alldetails ? (
                          <>
                            {customerProfile.address},
                            {customerProfile.city},
                            {customerProfile.PIN}
                          </>
                        ) : (
                          'GST address not available'
                        )
                      )}
                    </div>

                  </div>
                </div>
                <div className="col-md-6 text-md-end">
                  <div className="mb-3">
                    <div className="d-flex justify-content-end flex-wrap">
                      <span className="me-2 fw-bold">Invoice:</span>
                      <span>{generateInvoiceNumber()}</span>
                    </div>
                    <div className="d-flex justify-content-end flex-wrap">
                      <span className="me-2 fw-bold">Bill Date:</span>
                      <span>{getCurrentDate()}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mb-4 d-flex justify-content-between" style={{ fontSize: "14px" }}>
                <div className="col-md-6">
                  <h3 className="h5 border-bottom pb-2 fs-6" style={{ color: "#73be44" }}>Bill To</h3>
                  <div className="mb-3">
                    <div>Ceiba Green Solutions</div>
                    <div>GSTIN: 21AAICC3958J1ZK</div>
                    <div>Acharya Bihar, Bhubaneswar, Odisha, 751013</div>
                  </div>
                </div>
                <div className="col-md-6 text-md-end">
                  <h3 className="h5 border-bottom pb-2 text-end fs-6" style={{ color: "#73be44" }}>Place</h3>
                  <div className='d-flex justify-content-end'>
                    Bhubaneswar, Odisha
                  </div>
                </div>
              </div>

              {updatedItems?.length > 0 && (
                <div className="table-responsive mb-4">
                  <table className="table table-bordered" style={{ fontSize: '0.8rem' }}>
                    <thead className="table-light">
                      <tr>
                        <th className="text-start">Item Description</th>
                        <th className="text-center">Qty</th>
                        <th className="text-end">HSN</th>
                        {/* <th className="text-end">SGST (%)</th> */}
                        {isGst && (
                          <th className="text-end">CGST (₹)</th>

                        )}
                        {isGst && (
                          <th className="text-end">SGST (₹)</th>

                        )}
                        <th className="text-end">Amount (₹)</th>
                      </tr>
                    </thead>
                    <tbody>
                      {updatedItems.map((item) => (
                        <tr key={item.itemId}>
                          <td>{item.itemName}</td>
                          <td className="text-center">{item.quantity.toFixed(2)} {item.unit}</td>
                          <td className="text-end">{item.hsn}</td>
                          {/* <td className="text-end">{item.sgst_per_unit.toFixed(2)}</td> */}
                          {/* <td className="text-end">{item.sgst}</td> */}
                          {isGst && (
                            <th className="text-end">{item.sgst}</th>

                          )}
                          {/* <td className="text-end">{item.cgst_per_unit.toFixed(2)}</td> */}
                          {/* <td className="text-end">{item.cgst}</td> */}
                          {isGst && (
                            <th className="text-end">{item.cgst}</th>

                          )}
                          <td className="text-end fw-bold">{item.totalAmount}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}

              {updatedItems.length > 0 && (
                <div className="d-flex row justify-content-end" style={{ fontSize: "14px" }}>
                  <div className="col-lg-5 col-md-6 col-sm-6">
                    {/* <div className="border-bottom py-2 d-flex justify-content-between">
                      <span>Subtotal:</span>
                      <span>₹{totals.subtotal}</span>
                    </div> */}
                    {/* {isGst && (
                      <>
                        <div className="border-bottom py-2 d-flex justify-content-between">
                          <span>SGST:</span>
                          <span>₹{totals.sgst}</span>
                        </div>
                        <div className="border-bottom py-2 d-flex justify-content-between">
                          <span>CGST:</span>
                          <span>₹{totals.cgst}</span>
                        </div>
                      </>
                    )} */}
                    <div
                      className="py-2 px-2 d-flex justify-content-between"
                      style={{ color: "#8bcb63ff", fontWeight: "bold" }}
                    >
                      <span>TOTAL (₹):</span>
                      <span>₹{totals.grandTotal}</span>
                    </div>
                  </div>
                </div>
              )}

              <div className="mt-5 pt-4 border-top">
                <div className="col-12 mt-3">
                  <div className="print float-start d-flex">
                    <Link onClick={printReceipt}>
                      <i className="fa fa-print"></i>
                      Print this invoice
                    </Link>
                  </div>
                  <div className="print float-end d-flex">
                    <Link onClick={goBack}>
                      <i className="fa fa-arrow-left"></i>
                      Go Back
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <style>
        {`
          @media print {
            .print.float-start.d-flex {
              display: none !important;
            }
            .print.float-end.d-flex {
              display: none !important;
            }
          }
        `}
      </style>
    </div>
  );
};

export default Invoice;